import * as yup from 'yup';

import { formatMessage } from 'utils/messages/utils';

export default yup.object().shape({
  threadId: yup.number().nullable(),
  content: yup.string().trim().max(1000).required(formatMessage('ENTER_COMMENT')),
  version: yup.number().required()
});
